"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIB_VERSION = void 0;
// (C) 2021 GoodData Corporation
// DO NOT CHANGE THIS FILE, IT IS RE-GENERATED ON EVERY BUILD
exports.LIB_VERSION = "8.12.0";
//# sourceMappingURL=__version.js.map